module.exports = __webpack_public_path__ + "media/img/uploads/solutions-tall-thumb-03-9b6950cf0170250121a22239c69f8407.jpg";